<div
  [ngStyle]="{ width: width }"
  class="border bg-darkgray bg-opacity-50 border-darkgray rounded-bottom-1 border-top-0 px-2 fs-xs text-gray"
>
  {{ distance }}
</div>
